import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  acknowledgeEmergencyViaWebUi,
  EmergencyStatusReportUpdated,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useAcknowledgeEmergencyViaWebUi = (
  options: UseMutationOptions<
    EmergencyStatusReportUpdated,
    unknown,
    { publisherId: number },
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args: { publisherId: number }) =>
      extractData(
        acknowledgeEmergencyViaWebUi({
          path: { publisherId: args.publisherId },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['emergencyMode'] });
      options.onSuccess?.(...args);
    },
  });
};
